<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="payTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isHandleDelivery" slot-scope="data">
          <span>{{ data.row.isHandleDelivery === 1 ? '是' : '否' }}</span>
        </template>
        <template slot="isHandleOrder" slot-scope="data">
          <span>{{ data.row.isHandleOrder === 1 ? '是' : '否' }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USEREMPLOYEES',
        formComponent: {
          view: { type: 'component', componentName: 'StaffAccountView', value: 'queryUserEmployeesDetailData', noRequest: true },
          add: { type: 'component', componentName: 'UserEmployees-add', value: 'resetUserEmployeesDetailData' },
          edit: { type: 'component', componentName: 'UserEmployees-edit', value: 'queryUserEmployeesDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/userEmployees/userEmployeesList' },
          delete: { type: 'default', value: '/modules/userEmployees/userEmployeesDelete' }
        },
        formInputsData: [],
        // formInputsData: [
        //   { name: '登录用户名', key: 'userName', value: '', type: 'text' },
        //   { name: '文件名称', key: 'name', value: '', type: 'text' },
        //   { name: '修改时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false }],
        formTableData: [
          { name: '姓名', key: 'userName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '是否可以投递垃圾', key: 'isHandleDelivery', type: 'custom' },
          { name: '是否可以订单核销', key: 'isHandleOrder', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 200 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setUserEmployeesDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    }
  }
}
</script>
